// This component finds an ng1 card in the DOM and replaces it with a ngx sb-card-detail
// Menu items are passed in from the parent route

import { AfterContentChecked, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Buttons } from '@sb-shared/models/UI/buttons';
import { MenuItems } from '@sb-shared/models/UI/menu-item';

@Component({
    selector: 'sb-ng1-card-detail-wrapper',
    templateUrl: './ng1-card-detail-wrapper.component.html',
    styleUrls: ['./ng1-card-detail-wrapper.component.scss'],
    standalone: false
})
export class Ng1CardDetailWrapperComponent implements AfterContentChecked {
  @ViewChild('ng1CardDetail') ng1CardDetail: ElementRef;

  @Input() menuItems: MenuItems;
  @Input() isLoadingMenuItems: boolean;
  @Input() actions: Buttons;

  @Output() onClickAction: EventEmitter<number> = new EventEmitter();

  contentMoved: boolean;
  sbDetail: HTMLElement;

  ngAfterContentChecked() {
    this.sbDetail = document.getElementsByTagName('sb-detail')[0] as HTMLElement;
    const cardDetailNg1 = this.sbDetail?.querySelector('.card-detail');
    const cardDetailNgx = this.ng1CardDetail?.nativeElement;

    if (!cardDetailNg1 || !cardDetailNgx) {
      return;
    }

    const headingName = '.card-detail__item-heading';
    const headingNgx = cardDetailNgx.querySelector(headingName);
    const headingNg1 = cardDetailNg1.querySelector(headingName);

    // Move the ngx card detail into place once - this is a structural DOM move,
    // so it only needs to happen the first time both cards have rendered.
    if (!this.contentMoved && headingNgx && headingNg1) {
      cardDetailNg1.parentNode.append(cardDetailNgx);
      cardDetailNg1.classList.add('hidden');
      cardDetailNgx.classList.remove('hidden');
      this.contentMoved = true;
    }

    // Keep the heading in sync every cycle. It is bound to selectedEvent (which
    // changes as the user clicks rows) and AngularJS interpolates its bindings
    // *after* the element first appears - so copying only once froze the raw
    // "{{ ... }}" template text. Re-copy only when the content actually differs,
    // which fixes that regression without re-parsing identical HTML each cycle.
    if (headingNgx && headingNg1) {
      const headingNg1Html = headingNg1.innerHTML;
      // Skip until AngularJS has interpolated the bindings; copying while the
      // source still contains "{{ ... }}" markers would briefly flash the raw
      // template text in the Angular heading before the next cycle corrects it.
      if (!headingNg1Html.includes('{{') && headingNgx.innerHTML !== headingNg1Html) {
        headingNgx.innerHTML = headingNg1Html;
      }
    }
  }

  clickAction(event) {
    this.onClickAction.emit(event);
  }
}
